<template>
    <div v-show="show" class="createTimeOutList-container">
        <div v-show="showEdit" :class="{dialogContent: true, breaking: config.activeTab != 'punctual'}">
            <div class="title">{{config.activeTab == 'punctual' ? '新建定时单' : '新建突发单'}}</div>
            <img @click="close" class="close" src="./assets/close.png" alt="">
            <div class="content">
                <div class="left-container">
                    <img v-if="cover" :src="cover" alt="头图内容">
                    <div v-else class="noImg">
                        <i></i>
                        <span>无图片</span>
                    </div>
                    <div :class="{wordBg: true}"><i></i>{{content}}</div>
                    <div v-show="config.activeTab != 'punctual'" class="mainContent">{{mainContent}}</div>
                    <div class="notice">
                        <i></i>
                        <span>该预览仅展示文字与图片的布局，实际底版配色以上屏为准</span>
                    </div>
                </div>
                <div class="right-container">
                    <div class="row">
                        <div class="t alert">头图内容</div>
                        <img v-if="cover" class="pic" :src="cover" alt="头图内容">
                        <div v-else class="noImg">
                            <i></i>
                            <span>无图片</span>
                        </div>
                        <div v-if="cover" class="btns">
                            <p v-show="img_list.length > 1" @click="openImg(img_list)" class="change"><i></i><span>替换</span></p>
                            <div v-show="saveCover" @click="editPic" class="clip"><i></i><span>裁剪</span></div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="t alert">标题</div>
                        <textarea v-model="content" :maxlength="config.activeTab == 'punctual' ? 32 : 19" placeholder="请输入标题"></textarea>
                        <div class="num">{{content.length}}/{{config.activeTab == 'punctual' ? 32 : 19}}</div>
                    </div>
                    <div v-show="config.activeTab != 'punctual'" class="col">
                        <div class="t alert">正文</div>
                        <textarea class="mainContent" v-model="mainContent" placeholder="请输入正文" maxlength="95"></textarea>
                        <div class="num">{{mainContent.length}}/95</div>
                    </div>
                    <div v-show="config.activeTab == 'punctual'" class="row center">
                        <div class="t alert">上屏时间</div>
                        <el-date-picker popper-class="datePickerDom-poper" class="datePickerDom-date" v-model="screenDate" type="date" placeholder="选择日期" :picker-options="screenDatePickerOptions" value-format="yyyy-MM-dd" :clearable="true"></el-date-picker>
                        <el-time-picker class="datePickerDom-time" v-model="screenTime" placeholder="选择时间" format="HH:mm" value-format="HH:mm:ss" :clearable="true"></el-time-picker>
                    </div>
                    <div class="row center">
                        <div class="t alert">发生时间</div>
                        <el-date-picker popper-class="datePickerDom1-poper" class="datePickerDom1-date" v-model="happenDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" :clearable="true"></el-date-picker>
                        <el-time-picker class="datePickerDom1-time" v-model="happenTime" placeholder="选择时间" format="HH:mm" value-format="HH:mm:ss" :clearable="true"></el-time-picker>
                    </div>
                    <div v-show="config.activeTab == 'punctual'" class="row center">
                        <div class="t alert">优先级</div>
                        <!-- <div class="notice">
                            <p>数字越大，优先级越高</p>
                        </div> -->
                        <el-select class="prioritySelect" v-model="priority" placeholder="请选择优先级">
                            <el-option v-for="item in config.consult_priority_config" :key="item.key" :label="item.name" :value="item.key"></el-option>
                        </el-select>
                        <!-- <input class="priority" v-model="priority" placeholder="请输入优先级"> -->
                    </div>
                    <div v-show="config.activeTab == 'punctual'" class="row center">
                        <div class="t">循环设置</div>
                        <el-switch
                            v-model="isCycle"
                            active-color="#41B48C"
                            inactive-color="#ECEEEE">
                        </el-switch>
                        <div v-show="isCycle" class="select">
                            <span class="title">次数</span>
                            <el-select :disabled="!isCycle" popper-class="timeOutSelect" v-model="times">
                                <el-option v-for="item in config.consult_cycle_count" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                        </div>
                        <div v-show="isCycle" class="select">
                            <span class="title">间隔</span>
                            <el-select :disabled="!isCycle" popper-class="timeOutSelect" v-model="date">
                                <el-option v-for="item in config.consult_interval_time" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                            <span class="unit">分钟</span>
                            <div class="preview">
                                <div class="info">
                                    <span>循环上屏时间</span>
                                    <p v-for="item in cycleTimes" :key="item">{{item}}</p>
                                    <p v-if="cycleTimes.length == 0">无</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btns">
                <p @click="checkMust" class="btn g">确定</p>
                <p @click="close" class="btn">取消</p>
            </div>
        </div>

        <div v-show="!showEdit" :class="{confirmContent: true, breaking: config.activeTab != 'punctual'}">
            <img @click="showEdit = true" class="close" src="./assets/close.png" alt="">

            <div v-if="config.activeTab == 'punctual'" class="title">
                <p>请再次确认修改后的海报，确认无误后点击确认</p>
                <p>注意：确认后的海报无法再次修改</p>
            </div>
            <div v-if="overHour" class="alertNotice">上屏时间和发生时间，间隔超过24小时</div>
            <div v-if="config.activeTab == 'punctual'" class="previewDom">
                <img :src="cover" alt="">
                <div class="wordBg check"><i></i>{{content}}</div>
            </div>
            <div v-if="config.activeTab == 'punctual'" class="notice">
                <i></i>
                <span>该预览仅展示文字与图片的布局，实际底版配色以上屏为准</span>
            </div>

            <div v-if="config.activeTab != 'punctual'" class="breakingContent">
                <div class="previewDom">
                    <img :src="cover" alt="">
                    <div class="wordBg check"><i></i>{{content}}</div>
                    <div class="mainContent check">{{mainContent}}</div>
                </div>

                <div class="r">
                    <div class="title">
                        <p>请再次确认修改后的海报，确认无误后点击确认</p>
                        <p>注意：确认后的海报无法再次修改</p>
                    </div>
                    <div class="notice">
                        <i></i>
                        <span>该预览仅展示文字与图片的布局，实际底版配色以上屏为准</span>
                    </div>
                </div>
            </div>
            
            <div class="btns">
                <div @click="confirm" class="btn g">确认</div>
                <div @click="showEdit = true;isCreatePreview = false;overHour = false" class="btn">返回</div>
            </div>
        </div>
    </div>
</template>

<script>
import { Switch } from 'element-ui'
import { apis } from "@common/config";
import common from "@common/common";
export default {
    components: {
        'el-switch': Switch
    },
    data() {
        return {
            canUploadUrl: '',
            canUploadFileId: '',
            xnUpCfg: null,
            appId: null,
            appSecret: null,
            uploadUrl: null,
            circleList: [],
            showEdit: true,
            cover: '',
            placeholder: '',
            show: false,
            config: {},
            callback: null,
            title: '退回理由',
            canEdit: true,
            maxLength: 100,
            num: 0,
            content: '',
            singleBtn: false,
            errTitle: '退回理由不能为空',
            times: "1",
            date: "15",
            priority: 1,
            isCycle: false,
            screenDate: '',
            screenTime: '',
            happenDate: '',
            happenTime: '',
            img_list: [],
            cycleTimes: [],
            saveCover: '',
            hasUrl: false,
            isSubmiting: false,
            completed_img_url: '',
            isCreatePreview: false,
            mainContent: '',
            overHour: false
        }
    },
    computed: {
        datePicker() {
            if (this.screenDate && this.screenTime) {
                return this.screenDate + ' ' + this.screenTime;
            }
            if (this.screenDate) {
                return this.screenDate;
            }
            return '';
        },
        datePicker1() {
            if (this.happenDate && this.happenTime) {
                return this.happenDate + ' ' + this.happenTime;
            }
            if (this.happenDate) {
                return this.happenDate;
            }
            return '';
        },
        screenDatePickerOptions() {
            return {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
                }
            };
        }
    },
    methods: {
        checkMust() {
            // console.log(this.datePicker1)
            if(this.config.activeTab == 'punctual'){
                if(!this.cover){
                    this.$toast('头图内容不能为空')
                    return false;
                }
                if(!this.content){
                    this.$toast('标题不能为空')
                    return false;
                }
                if(!this.datePicker){
                    this.$toast('上屏时间不能为空')
                    return false;
                }
                if(!this.priority){
                    this.$toast('优先级不能为空')
                    return false;
                }
            }else{
                if(!this.cover){
                    this.$toast('头图内容不能为空')
                    return false;
                }
                if(!this.content){
                    this.$toast('标题不能为空')
                    return false;
                }
                if(!this.mainContent){
                    this.$toast('正文不能为空')
                    return false;
                }
            }

            if(!this.datePicker1 && this.datePicker1 != '0000-00-00 00:00:00'){
                this.$toast('发生时间不能为空')
                return false;
            }
            if(this.datePicker1 && this.datePicker && this.config.activeTab == 'punctual'){
                const happenTime = new Date(this.datePicker1);
                const screenTime = new Date(this.datePicker);
                const timeDiff = Math.abs(screenTime - happenTime);
                const hoursDiff = timeDiff / (1000 * 60 * 60);
                if(hoursDiff > 24){
                    this.overHour = true
                    this.$fullTitle({title: '提示', msg: '上屏时间和发生时间，间隔超过24小时。'})
                }
            }
            
            this.showEdit = false;

            this.$nextTick(() => {
                this.isCreatePreview = true
                this.$imgLoading.open()
                this.screenshotPreviewDom().then(res => {
                    this.streamPreviewUpload(this.content,res)
                });
            })
        },
                                getSeeMainContent() {
            const wordBgElement = document.querySelector('.mainContent.check');
            if (!wordBgElement) {
                console.error('mainContent element not found');
                return '';
            }

            const computedStyle = window.getComputedStyle(wordBgElement);
            const paddingTop = parseFloat(computedStyle.paddingTop) || 0;
            const paddingBottom = parseFloat(computedStyle.paddingBottom) || 0;
            const paddingLeft = parseFloat(computedStyle.paddingLeft) || 0;
            const paddingRight = parseFloat(computedStyle.paddingRight) || 0;
            
            const availableHeight = wordBgElement.offsetHeight - paddingTop - paddingBottom;
            const availableWidth = wordBgElement.offsetWidth - paddingLeft - paddingRight;

            const fullText = wordBgElement.textContent.trim();
            if (!fullText) return '';

            // Create a temporary div that mimics the original element's styling
            const measureDiv = document.createElement('div');
            measureDiv.style.position = 'absolute';
            measureDiv.style.visibility = 'hidden';
            measureDiv.style.width = availableWidth + 'px';
            measureDiv.style.height = availableHeight + 'px';
            measureDiv.style.fontSize = computedStyle.fontSize;
            measureDiv.style.fontFamily = computedStyle.fontFamily;
            measureDiv.style.lineHeight = computedStyle.lineHeight;
            measureDiv.style.letterSpacing = computedStyle.letterSpacing;
            measureDiv.style.fontWeight = computedStyle.fontWeight;
            measureDiv.style.wordWrap = 'break-word';
            measureDiv.style.wordBreak = 'break-all';
            measureDiv.style.whiteSpace = 'pre-wrap';
            measureDiv.style.boxSizing = 'border-box';
            measureDiv.style.overflow = 'hidden';

            document.body.appendChild(measureDiv);

            let visibleText = '';
            let testText = '';

            // Binary search for better performance
            let left = 0;
            let right = fullText.length;
            
            while (left < right) {
                const mid = Math.floor((left + right + 1) / 2);
                testText = fullText.substring(0, mid);
                measureDiv.textContent = testText;
                
                if (measureDiv.scrollHeight <= availableHeight) {
                    left = mid;
                    visibleText = testText;
                } else {
                    right = mid - 1;
                }
            }

            document.body.removeChild(measureDiv);

            console.log('Visible mainContent text:', visibleText);
            return visibleText;
        },
        getSeeContent() {
            const wordBgElement = document.querySelector('.wordBg.check');
            if (!wordBgElement) {
                console.error('wordBg element not found');
                return '';
            }

            const computedStyle = window.getComputedStyle(wordBgElement);
            const paddingTop = parseFloat(computedStyle.paddingTop) || 0;
            const paddingBottom = parseFloat(computedStyle.paddingBottom) || 0;
            const paddingLeft = parseFloat(computedStyle.paddingLeft) || 0;
            const paddingRight = parseFloat(computedStyle.paddingRight) || 0;

            // console.log(paddingTop,paddingBottom,paddingLeft,paddingRight,wordBgElement)
            
            const availableHeight = wordBgElement.offsetHeight - paddingTop - paddingBottom;
            const availableWidth = wordBgElement.offsetWidth - paddingLeft - paddingRight;

            // Get the <i> tag width if it exists
            const iTag = wordBgElement.querySelector('i');
            let iTagWidth = 0;
            if (iTag) {
                const iStyle = window.getComputedStyle(iTag);
                const iWidth = parseFloat(iStyle.width) || 0;
                const marginLeft = parseFloat(iStyle.marginLeft) || 0;
                const marginRight = parseFloat(iStyle.marginRight) || 0;
                iTagWidth = iWidth + marginLeft + marginRight;
            }
            
            const textWidth = availableWidth - iTagWidth;

            // Get text content (excluding <i> tag)
            const textNodes = [];
            function findTextNodes(node) {
                if (node.nodeType === Node.TEXT_NODE) {
                    const text = node.textContent.trim();
                    if (text) textNodes.push(text);
                } else if (node.nodeType === Node.ELEMENT_NODE && node.tagName !== 'I') {
                    for (let child of node.childNodes) {
                        findTextNodes(child);
                    }
                }
            }
            findTextNodes(wordBgElement);
            
            const fullText = textNodes.join('');
            if (!fullText) return '';

            // Create a temporary div that mimics the original element's styling
            const measureDiv = document.createElement('div');
            measureDiv.style.position = 'absolute';
            measureDiv.style.visibility = 'hidden';
            measureDiv.style.width = textWidth + 'px';
            measureDiv.style.height = availableHeight + 'px';
            measureDiv.style.fontSize = computedStyle.fontSize;
            measureDiv.style.fontFamily = computedStyle.fontFamily;
            measureDiv.style.lineHeight = computedStyle.lineHeight;
            measureDiv.style.letterSpacing = computedStyle.letterSpacing;
            measureDiv.style.fontWeight = computedStyle.fontWeight;
            measureDiv.style.wordWrap = 'break-word';
            measureDiv.style.wordBreak = 'break-all';
            measureDiv.style.whiteSpace = 'pre-wrap';
            measureDiv.style.boxSizing = 'border-box';
            measureDiv.style.overflow = 'hidden';

            document.body.appendChild(measureDiv);

            let visibleText = '';

            // Binary search for better performance
            let left = 0;
            let right = fullText.length;

            while (left < right) {
                const mid = Math.floor((left + right + 1) / 2);
                const testText = fullText.substring(0, mid);
                measureDiv.textContent = testText;

                if (measureDiv.scrollHeight <= availableHeight) {
                    left = mid;
                    visibleText = testText;
                } else {
                    right = mid - 1;
                }
            }

            document.body.removeChild(measureDiv);

            console.log('Visible text:', visibleText);
            return visibleText;
        },
        async screenshotPreviewDom() {
            // Get the previewDom element
            const previewDom = document.querySelector('.previewDom');
            if (!previewDom) {
                console.error('previewDom element not found');
                return null;
            }
            
            try {
                // Create a canvas element
                const canvas = document.createElement('canvas');
                const rect = previewDom.getBoundingClientRect();
                
                // Set canvas size
                canvas.width = rect.width;
                canvas.height = rect.height;
                const ctx = canvas.getContext('2d');
                
                // Draw the element onto canvas
                // Note: This method has limitations with complex CSS and cross-origin images
                // For production use, consider adding html2canvas library
                
                // First, draw a white background
                ctx.fillStyle = '#39464f';
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                
                // Get all child elements
                const children = previewDom.children;
                for (let i = 0; i < children.length; i++) {
                    const child = children[i];
                    const childRect = child.getBoundingClientRect();
                    const childX = childRect.left - rect.left;
                    const childY = childRect.top - rect.top;
                    
                    if (child.tagName === 'IMG') {
                        // Handle image elements
                        const img = child;
                        if (img.complete) {
                            ctx.drawImage(img, childX, childY, childRect.width, childRect.height);
                        } else {
                            // Wait for image to load
                            await new Promise((resolve) => {
                                img.onload = () => {
                                    ctx.drawImage(img, childX, childY, childRect.width, childRect.height);
                                    resolve();
                                };
                                img.onerror = resolve;
                            });
                        }
                    } else if ((child.tagName === 'DIV' && child.classList.contains('wordBg')) || (child.tagName === 'DIV' && child.classList.contains('mainContent'))) {
                        // Handle text elements and i tag icon
                        const computedStyle = window.getComputedStyle(child);
                        
                        // Check for i tag inside wordBg
                        const iTag = child.querySelector('i');
                        if (iTag) {
                            // Process i tag
                            const iComputedStyle = window.getComputedStyle(iTag);
                            const iRect = iTag.getBoundingClientRect();
                            const wordBgRect = child.getBoundingClientRect();
                            const iX = iRect.left - wordBgRect.left + childX;
                            const iY = iRect.top - wordBgRect.top + childY;
                            const iWidth = iRect.width;
                            const iHeight = iRect.height;
                            
                            // Check if i tag has background image
                            const backgroundImage = iComputedStyle.backgroundImage;
                            if (backgroundImage && backgroundImage !== 'none') {
                                // Extract URL from backgroundImage
                                const urlMatch = backgroundImage.match(/url\(["']?([^"']*)["']?\)/);
                                if (urlMatch) {
                                    const imgUrl = urlMatch[1];
                                    const img = new Image();
                                    img.crossOrigin = 'anonymous';
                                    // Wait for image to load
                                    await new Promise((resolve) => {
                                        img.onload = () => {
                                            ctx.drawImage(img, iX, iY, iWidth, iHeight);
                                            resolve();
                                        };
                                        img.onerror = resolve;
                                        img.src = imgUrl;
                                    });
                                }
                            }
                        }
                        
                        // Now draw the text
                        const text = child.textContent;
                        ctx.font = `${computedStyle.fontSize} ${computedStyle.fontFamily}`;
                        ctx.fillStyle = computedStyle.color;
                        ctx.textAlign = 'left';
                        ctx.textBaseline = 'top';
                        
                        // Simple text rendering (may not handle complex formatting)
                        const lines = text.split('\n');
                        let lineHeight = parseInt(computedStyle.lineHeight) || 20;
                        const indent = 46; // First line indentation in pixels
                        
                        lines.forEach((line, index) => {
                            const x = index === 0 ? childX + indent : childX;
                            ctx.fillText(line, x, childY + index * lineHeight);
                        });
                    }
                }
                
                // Convert canvas to data URL
                const dataURL = canvas.toDataURL('image/jpeg');
                // console.log('Screenshot captured:', dataURL);
                return dataURL;
            } catch (error) {
                console.error('Error capturing screenshot:', error);
                return null;
            }
        },
        getNewImg(res) {
            // console.log(res.url)
            this.saveCover = res.url
            this.processCoverImage(res.url);
            this.hasUrl = false;
        },
        setCover(url){
            this.cover = url
            this.hasUrl = false;
        },
        editPic(){
            this.$sportPicEdit({
                url: this.saveCover
            },this.setCover)
        },
        openImg (urlList) { 
            // console.log(33213123,urlList)
            this.$libraryMaterialImgList(urlList, this.getNewImg).then(res => { 
                if(res){
                    this.getNewImg(res)
                }
            })
        },
        open(config, callback) {

            if(config.consult_default_priority){
                this.priority = Number(config.consult_default_priority)
            }
            this.overHour = false;
            this.content = ''
            this.isCreatePreview = false;
            this.completed_img_url = ''
            this.isSubmiting = false;
            this.showEdit = true;
            this.getAsperaConfig()
            this.getConfig()
            this.config = config;
            this.callback = callback;
            this.show = true;
            this.getDetail()

            if(config.consult_cycle_count && config.consult_cycle_count.length){
                this.times = config.consult_cycle_count[0]
            }

            if(config.consult_interval_time && config.consult_interval_time.length){
                this.date = config.consult_interval_time[0]
            }
            
            // 计算默认的上屏时间
            this.calculateDefaultTime();

            // setTimeout(() => {
            //     let dom = document.querySelectorAll('.datePickerDom .mx-datepicker-popup .mx-panel-time .mx-time-list')
            //     if(dom.length){
            //         dom = dom[1]

            //         let list = dom.querySelectorAll('.cell')

            //         for(let i = 0; i < list.length; i++){ 
            //             let item = list[i]
            //             if(item.innerText != '00' &&item.innerText != '15' && item.innerText != '30' && item.innerText != '45' ){
            //                 item.style.display = 'none'
            //             }
            //         }
            //     }
            // }, 500)
            
        },
        calculateDefaultTime() {
            const now = new Date();
            const year = now.getFullYear();
            const month = now.getMonth();
            const day = now.getDate();
            const hour = now.getHours();
            const minute = now.getMinutes();
            
            let targetHour = hour;
            let targetDay = day;
            let targetMinute = 0;
            
            if (minute >= 0 && minute < 10) {
                // 0-10分设置成15分
                targetMinute = 15;
            } else if (minute >= 10 && minute < 40) {
                // 10-40分设置成45分
                targetMinute = 45;
            } else {
                // 40-60分设置成下一个准点的15分
                targetHour = hour + 1;
                targetMinute = 15;
                
                // 处理跨天的情况
                if (targetHour >= 24) {
                    targetHour -= 24;
                    targetDay += 1;
                }
            }
            
            // 创建目标时间
            const targetDate = new Date(year, month, targetDay, targetHour, targetMinute, 0);
            
            // 格式化时间为 YYYY-MM-DD HH:mm 格式
            const formattedDate = this.formatDate(targetDate);
            this.screenDate = formattedDate.split(' ')[0];
            this.screenTime = formattedDate.split(' ')[1];
        },
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hour = String(date.getHours()).padStart(2, '0');
            const minute = String(date.getMinutes()).padStart(2, '0');
            return `${year}-${month}-${day} ${hour}:${minute}:00`;
        },
        
        getDetail() {
            
            let data = {
                doc_id: this.config ? this.config.id : '',
                from_req: 1,
                consult_type: this.config.activeTab == 'punctual' ? 1 : 2
            }
            common.myFetch(apis.sourceDocDetail,data).then(res => {
                // console.log(res)
                if (res) {
                    if(res.happen_time){
                        const parts = res.happen_time.split(' ');
                        this.happenDate = parts[0] || '';
                        this.happenTime = parts[1] || '';
                    }
                    // 处理封面图片，根据宽高比进行截取
                    if (res.cover) {
                        this.saveCover = res.cover
                        this.processCoverImage(res.cover);
                    }

                    if (res.title) {
                        // consult_type: 1 => 标题处理；2 => 标题+正文处理
                        const consultType = this.config && this.config.activeTab == 'punctual' ? 1 : 2;
                        if (consultType === 1) {
                            this.consultRenTitle(res.title);
                        } else if (consultType === 2 && res.content) {
                            this.consultRenTitleContent(res.title, res.content);
                        } else {
                            this.consultRenTitle(res.title);
                        }
                    }
                    if(res.img_list){
                        this.img_list = res.img_list
                    }else{
                        this.img_list = []
                    }
                }
            })
        },
        consultRenTitle(title) {
            common.myFetch(apis.consultRenTitle,{title: title}).then(res => { 
                if(res){
                    this.content = res.title ? res.title.slice(0, 32) : ''
                }
            })
        },
        consultRenTitleContent(title, content) {
            common.myFetch(apis.consultRenTitle,{title: title, content: content}).then(res => { 
                if(res){
                    this.content = res.title ? res.title.slice(0, 19) : ''
                    this.mainContent = res.content ? res.content.slice(0, 95) : ''
                }
            })
        },
        processCoverImage(coverUrl) {
            // 创建图片对象来获取宽高
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = async () => {
                try {
                    const width = img.width;
                    const height = img.height;
                    const aspectRatio = width / height;
                    const targetRatio = 16 / 9;
                    
                    let processedUrl = coverUrl;
                    
                    if (aspectRatio > targetRatio) {
                        // 横图：按高截取成16:9
                        // 计算需要截取的宽度
                        const targetWidth = height * targetRatio;
                        const offsetX = (width - targetWidth) / 2;
                        // 生成截取后的URL
                        processedUrl = await this.addImageProcessParams(coverUrl, {
                            cropWidth: Math.round(targetWidth),
                            cropHeight: height,
                            x: Math.round(offsetX),
                            y: 0
                        });
                    } else {
                        // 竖图：按宽截取成16:9
                        // 计算需要截取的高度
                        const targetHeight = width / targetRatio;
                        const offsetY = (height - targetHeight) / 2;
                        // 生成截取后的URL
                        processedUrl = await this.addImageProcessParams(coverUrl, {
                            cropWidth: width,
                            cropHeight: Math.round(targetHeight),
                            x: 0,
                            y: Math.round(offsetY)
                        });
                    }

                    // console.log(processedUrl)
                    
                    this.cover = processedUrl;
                } catch (error) {
                    console.error('Error processing cover image:', error);
                    // If processing fails, use original URL
                    this.cover = coverUrl;
                }
            };
            img.onerror = () => {
                console.error('Error loading cover image');
                // If image fails to load, use original URL
                this.cover = coverUrl;
            };
            img.src = coverUrl;
        },
        addImageProcessParams(url, params) {
            return new Promise((resolve) => {
                const img = new Image();
                // Add crossOrigin attribute to handle CORS
                img.crossOrigin = 'anonymous';
                img.onload = () => {
                    try {
                        const canvas = document.createElement('canvas');
                        const ctx = canvas.getContext('2d');
                        const { cropWidth, cropHeight, x, y } = params;
                        canvas.width = cropWidth;
                        canvas.height = cropHeight;
                        ctx.drawImage(img, x, y, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);
                        const processedUrl = canvas.toDataURL('image/jpeg');
                        resolve(processedUrl);
                    } catch (error) {
                        console.error('Error processing image:', error);
                        // If canvas processing fails due to CORS, resolve with original URL
                        resolve(url);
                    }
                };
                img.onerror = () => {
                    // If image fails to load, resolve with original URL
                    resolve(url);
                };
                img.src = url;
            });
        },
        confirm() {
            console.log('confirm')
            if(this.isCreatePreview){
                this.$toast('预览图生成中')
                return
            }
            if(this.isSubmiting) return
            this.isSubmiting = true;
            if(this.hasUrl){
                let screenTimeVal;
                // Check if datePicker is a timestamp (number)
                if (typeof this.datePicker === 'number') {
                    // Convert timestamp to Date object first, then format
                    screenTimeVal = common.stampToTime(new Date(this.datePicker));
                } else if (this.datePicker instanceof Date) {
                    // If it's already a Date object, use stampToTime
                    screenTimeVal = common.stampToTime(this.datePicker);
                } else {
                    // If it's already a string, return it directly
                    screenTimeVal = this.datePicker;
                }
                let happy_time = '';

                if(this.datePicker1){
                    // Check if datePicker is a timestamp (number)
                    if (typeof this.datePicker1 === 'number') {
                        // Convert timestamp to Date object first, then format
                        happy_time = common.stampToTime(new Date(this.datePicker1));
                    } else if (this.datePicker1 instanceof Date) {
                        // If it's already a Date object, use stampToTime
                        happy_time = common.stampToTime(this.datePicker1);
                    } else {
                        // If it's already a string, return it directly
                        happy_time = this.datePicker1;
                    }
                }

                let subTitle = '';

                let breakContent = ''

                subTitle = this.getSeeContent()

                breakContent = this.getSeeMainContent()

                console.log('this.config.activeTab', this.config.activeTab)
                
                const consultType = this.config.activeTab == 'punctual' ? 1 : 2;

                let data = {
                    img_url: this.canUploadUrl,
                    material_id: this.canUploadFileId,
                    title: subTitle,
                    screen_time: screenTimeVal,
                    happy_time: happy_time,
                    priority: this.priority,
                    is_cycle_screen: this.isCycle ? 1 : 0,
                    cycle_count: this.times,
                    interval_time: this.date,
                    unified_content_id: this.config.id,
                    completed_img_url: this.completed_img_url,
                    consult_type: consultType
                }

                // 突发单（consult_type=2）才传正文内容
                if (consultType === 2) {
                    data.content = breakContent;
                }
                common.myFetch(apis.consultPush,data).then(res => {
                    this.isSubmiting = false;
                    if (res) {
                        this.$toast('新建成功');
                        this.cover = '';
                        this.saveCover = '';
                        this.content = '';
                        this.priority = 1;
                        this.screenDate = '';
                        this.screenTime = '';
                        this.happenDate = '';
                        this.happenTime = '';
                        this.times = '1'
                        this.date = '15'
                        this.show = false;
                        this.isCycle = false
                        // let dom = document.querySelector('.sports-up-content .refresh-btn');
                        // console.log(dom)
                        // if(dom){
                        //     dom.click()
                        // }
                        this.config.freshFn()

                        this.$newLibraryMaterial().close()
                    }
                }).catch(err => {
                    this.isSubmiting = false;
                })
            }else{
                console.log('streamUpload')
                this.streamUpload(this.content,this.cover)
            }
        },
        cancel() {
            this.$confirm('是否确定取消？取消后任务将被删除。').then((res) => {
                if(res){
                    this.show = false;
                    this.$newLibraryMaterial().close()
                }
            })
        },
        async close() {
            this.show = false;
            this.cover = '';
            this.saveCover = '';
            this.content = '';
            this.priority = 1;
            this.screenDate = '';
                        this.screenTime = '';
            this.happenDate = '';
                        this.happenTime = '';
            this.times = '1'
            this.date = '15'
            this.isCycle = false
            this.isSubmiting = false;
        },
        handleDateChange(value) {
            if (value) {
                const date = new Date(value);
                let minutes = date.getMinutes();
                
                // Round to nearest 00, 15, 30, or 45 minutes
                const roundedMinutes = Math.round(minutes / 15) * 15;
                
                // Handle case where rounding goes to 60 minutes
                if (roundedMinutes === 60) {
                    date.setHours(date.getHours() + 1);
                    date.setMinutes(0, 0, 0);
                } else {
                    date.setMinutes(roundedMinutes, 0, 0);
                }
                
                // Format back to yyyy-MM-dd HH:mm
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hour = String(date.getHours()).padStart(2, '0');
                const formattedMinutes = String(date.getMinutes()).padStart(2, '0');
                
                this.screenDate = year + '-' + month + '-' + day;
                this.screenTime = hour + ':' + formattedMinutes + ':00';
            }
        },
        calculateCycleTimes() {
            if (!this.isCycle || !this.datePicker) {
                this.cycleTimes = [];
                return;
            }
            
            const cycleTimes = [];
            const startTime = new Date(this.datePicker);
            const intervalMinutes = parseInt(this.date);
            const cycleCount = parseInt(this.times);
            
            for (let i = 0; i <= cycleCount; i++) {
                const currentTime = new Date(startTime);
                currentTime.setMinutes(startTime.getMinutes() + (i * intervalMinutes));
                
                // Format time as YYYY-MM-DD HH:mm
                const year = currentTime.getFullYear();
                const month = String(currentTime.getMonth() + 1).padStart(2, '0');
                const day = String(currentTime.getDate()).padStart(2, '0');
                const hour = String(currentTime.getHours()).padStart(2, '0');
                const minute = String(currentTime.getMinutes()).padStart(2, '0');
                
                cycleTimes.push(`${year}-${month}-${day} ${hour}:${minute}`);
            }
            
            this.cycleTimes = cycleTimes;
        },
        addAssetsToPage(data) {
            // console.log('更新到接口', data,this.t);
            const filelist = [];
            data.forEach(i => {
                // console.log(i)
                const type = 1;
                // 将文件名改为截取前40位加后缀名
                const fileName = i.pureName || i.title || i.filename || i.name || "";
                const nameParts = fileName.split(".")[0];
                const ext = i.path.split('/').pop().split('.').pop();
                let nameLeft = nameParts;
                nameLeft = nameLeft.substr(0, 40);
                const filetitle = `${nameLeft}.${ext}`;
                // console.log(filetitle)
                let file = {
                    type: type,
                    title: filetitle,
                    path: i.targetPath || i.path,
                    subject_id: '',
                    subject_type: ''
                };
                

                filelist.push(file);
            });

            const info = { file_info: JSON.stringify(filelist) };
            return common.myFetch(apis.File_add, info).then(r => {
                if (r) {
                    this.$imgLoading.close()
                    this.hasUrl = true;
                    this.canUploadUrl = r.list[0].download_url;
                    this.canUploadFileId = r.list[0].file_id
                    let screenTimeVal;
                    // Check if datePicker is a timestamp (number)
                    if (typeof this.datePicker === 'number') {
                        // Convert timestamp to Date object first, then format
                        screenTimeVal = common.stampToTime(new Date(this.datePicker));
                    } else if (this.datePicker instanceof Date) {
                        // If it's already a Date object, use stampToTime
                        screenTimeVal = common.stampToTime(this.datePicker);
                    } else {
                        // If it's already a string, return it directly
                        screenTimeVal = this.datePicker;
                    }
                    let happy_time = '';

                    if(this.datePicker1){
                        // Check if datePicker is a timestamp (number)
                        if (typeof this.datePicker1 === 'number') {
                            // Convert timestamp to Date object first, then format
                            happy_time = common.stampToTime(new Date(this.datePicker1));
                        } else if (this.datePicker1 instanceof Date) {
                            // If it's already a Date object, use stampToTime
                            happy_time = common.stampToTime(this.datePicker1);
                        } else {
                            // If it's already a string, return it directly
                            happy_time = this.datePicker1;
                        }
                    }

                    let subTitle = '';

                    let breakContent = '';

                    subTitle = this.getSeeContent();

                    breakContent = this.getSeeMainContent()
                    
                    const consultType = this.config.activeTab == 'punctual' ? 1 : 2;

                    let data = {
                        img_url: this.canUploadUrl,
                        material_id: this.canUploadFileId,
                        title: subTitle,
                        screen_time: screenTimeVal,
                        happy_time: happy_time,
                        priority: this.priority,
                        is_cycle_screen: this.isCycle ? 1 : 0,
                        cycle_count: this.times,
                        interval_time: this.date,
                        unified_content_id: this.config.id,
                        completed_img_url: this.completed_img_url,
                        consult_type: consultType
                    }

                    // 突发单（consult_type=2）才传正文内容
                    if (consultType === 2) {
                        data.content = breakContent;
                    }
                    common.myFetch(apis.consultPush,data).then(res => {
                        this.isSubmiting = false;
                        if (res) {
                            this.$toast('新建成功');
                            this.cover = '';
                            this.saveCover = '';
                            this.content = '';
                            this.priority = 1;
                            this.screenDate = '';
                        this.screenTime = '';
                            this.happenDate = '';
                        this.happenTime = '';
                            this.times = '1'
                            this.date = '15'
                            this.show = false;
                            this.isCycle = false
                            this.config.freshFn()
                            this.$newLibraryMaterial().close()
                        }
                    }).catch(err => {
                        this.isSubmiting = false;
                    })
                }else{
                    this.isSubmiting = false;
                    this.$imgLoading.close()
                }
            });
        },
        addAssetsToPreview(data) {
            // console.log('更新到接口', data,this.t);
            const filelist = [];
            data.forEach(i => {
                // console.log(i)
                const type = 1;
                // 将文件名改为截取前40位加后缀名
                const fileName = i.pureName || i.title || i.filename || i.name || "";
                const nameParts = fileName.split(".")[0];
                const ext = i.path.split('/').pop().split('.').pop();
                let nameLeft = nameParts;
                nameLeft = nameLeft.substr(0, 40);
                const filetitle = `${nameLeft}.${ext}`;
                // console.log(filetitle)
                let file = {
                    type: type,
                    title: filetitle,
                    path: i.targetPath || i.path,
                    subject_id: '',
                    subject_type: ''
                };
                

                filelist.push(file);
            });

            const info = { file_info: JSON.stringify(filelist) };
            return common.myFetch(apis.File_add, info).then(r => {
                if (r) {
                    this.$imgLoading.close()
                    this.isCreatePreview = false;
                    this.completed_img_url = r.list[0].download_url; 
                }else{
                    this.$imgLoading.close()
                    this.isCreatePreview = false;
                }
            });
        },
        streamUpload(name, file) {
            // console.log(file)
            var that = this;
            var upConfig = this.xnUpCfg
            var filename = name
            var uniname = common.uniKey()
            var platform = common.getPlatform()
            var ext = 'jpg'
            var fileNameId = upConfig.fileNameId
            var httpPath = upConfig.httpPath
            var path = httpPath + '/' + fileNameId + platform + uniname + '.' + ext
            if(!name){
                name = fileNameId + platform + uniname + '.' + ext
            }
            const info = { 
                targetPath: path,
                appId: this.appId,
                appSecret: this.appSecret
            };

            // Convert base64 to binary Blob if file is base64
            let binaryFile = file;
            if (typeof file === 'string' && file.startsWith('data:')) {
                // Extract base64 data
                const arr = file.split(',');
                const mime = arr[0].match(/:(.*?);/)[1];
                const bstr = atob(arr[1]);
                let n = bstr.length;
                const u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                binaryFile = new Blob([u8arr], { type: mime });
            }

            var _url = this.uploadUrl + "/streamUpload?targetPath="+info.targetPath+"&appId="+info.appId+"&appSecret="+info.appSecret;
            var _xhr = new XMLHttpRequest;

            _xhr.ontimeout = function () {
                that.isSubmiting = false;
                console.error('The request for ' + _url + ' timed out.');
            };

            _xhr.onreadystatechange = function() {
                // console.log(_xhr.responseText)
                if (_xhr.readyState != 4 || _xhr.status < 200)
                return false;
                let data = JSON.parse(_xhr.responseText)
                if(data.success){
                    // console.log(data)
                    data.targetPath = data.path;
                    data.name = name;
                    that.addAssetsToPage([data])
                }else{
                    that.isSubmiting = false;
                    that.$imgLoading.close()
                    that.showSelect = false;
                    that.showFail = true;
                    that.canEditImg = true
                    that.alertWord = '网络连接超时'
                }
            }

            _xhr.timeout = 60 * 1000;
            _xhr.open("POST", _url, !0);
            _xhr.send(binaryFile);
        },

        streamPreviewUpload(name, file) {
            // console.log(file)
            var that = this;
            var upConfig = this.xnUpCfg
            var filename = name
            var uniname = common.uniKey()
            var platform = common.getPlatform()
            var ext = 'jpg'
            var fileNameId = upConfig.fileNameId
            var httpPath = upConfig.httpPath
            var path = httpPath + '/' + fileNameId + platform + uniname + '.' + ext
            if(!name){
                name = fileNameId + platform + uniname + '.' + ext
            }
            const info = { 
                targetPath: path,
                appId: this.appId,
                appSecret: this.appSecret
            };

            // Convert base64 to binary Blob if file is base64
            let binaryFile = file;
            if (typeof file === 'string' && file.startsWith('data:')) {
                // Extract base64 data
                const arr = file.split(',');
                const mime = arr[0].match(/:(.*?);/)[1];
                const bstr = atob(arr[1]);
                let n = bstr.length;
                const u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                binaryFile = new Blob([u8arr], { type: mime });
            }

            var _url = this.uploadUrl + "/streamUpload?targetPath="+info.targetPath+"&appId="+info.appId+"&appSecret="+info.appSecret;
            var _xhr = new XMLHttpRequest;

            _xhr.ontimeout = function () {
                that.isCreatePreview = false;
                console.error('The request for ' + _url + ' timed out.');
            };

            _xhr.onreadystatechange = function() {
                // console.log(_xhr.responseText)
                if (_xhr.readyState != 4 || _xhr.status < 200)
                return false;
                let data = JSON.parse(_xhr.responseText)
                if(data.success){
                    // console.log(data)
                    data.targetPath = data.path;
                    data.name = name;
                    that.addAssetsToPreview([data])
                }else{
                    that.$imgLoading.close()
                    that.showSelect = false;
                    that.showFail = true;
                    that.canEditImg = true
                    that.alertWord = '网络连接超时'
                    that.isCreatePreview = false;
                }
            }

            _xhr.timeout = 60 * 1000;
            _xhr.open("POST", _url, !0);
            _xhr.send(binaryFile);
        },
        getConfig() {
            return common.getFileConfigs()
            .then(r => {
                this.appId = r.app_id
                this.appSecret = r.app_secret
                this.uploadUrl = r.url
            })
        },
        getAsperaConfig() {
            // 获取aspera上传配置
            return common.myFetch(apis.File_Aspera)
            .then(r => {
                if (r) {
                    this.xnUpCfg = {
                        asperaPath: r.aspera_path,
                        httpPath: r.original_path,
                        fileNameId: r.filename_id
                    }
                }
            })
        }
    },
    watch: {
        screenDate() {
            this.calculateCycleTimes();
        },
        screenTime() {
            this.calculateCycleTimes();
        },
        times() {
            this.calculateCycleTimes();
        },
        date() {
            this.calculateCycleTimes();
        },
        isCycle() {
            this.calculateCycleTimes();
        }
    }
}
</script>

<style lang="less">
    @font-face {
        font-family: 'HYQiHei70S';
        src: url('/font/SourceHanSansCN-Bold.otf') format('truetype');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'HYQiHei70normal';
        src: url('/font/SourceHanSansCN-Normal.otf') format('truetype');
        font-weight: normal;
        font-style: normal;
    }

    // 汉仪旗黑70s字体类
    .hyqihei70s {
        font-family: 'HYQiHei70S', sans-serif;
    }

    .createTimeOutList-container {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1001;
        background-color: rgba(50, 59, 75, 0.3);
        backdrop-filter: blur(1.6px);

        .previewDom {
            display: flex;
            flex-direction: column;
        }

        .confirmContent {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 696px;
            min-height: 665px;
            transform: translate(-50%, -50%);
            display: flex;
            flex-direction: column;
            align-items: center;
            background: #F9F9F9;
            box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
            border-radius: 4px;
            padding: 40px 30px 40px;
            box-sizing: border-box;

            &.breaking {
                width: 912px;
                height: 626px;

                .breakingContent {
                    display: flex;
                    align-items: center;
                    flex: 1;
                    min-height: 0;
                    width: 100%;

                    .previewDom {
                        margin-right: 35px;

                        img {
                            width: 277px;
                            height: 156px;
                        }

                        .wordBg {
                            position: relative;
                            display: flex;
                            align-items: flex-start;
                            width: 277px;
                            height: 58px;
                            background: #39464F;
                            font-family: 'HYQiHei70S', sans-serif;
                            font-weight: bold;
                            font-size: 20px;
                            color: #FFFFFF;
                            line-height: 23px;
                            text-align: left;
                            font-style: normal;
                            letter-spacing: 0px;
                            padding: 6px 48px 0px 4px !important;
                            box-sizing: border-box;
                            white-space: pre-wrap;
                            word-break: break-all;
                            overflow: hidden;

                            i {
                                display: flex;
                                width: 9px;
                                min-width: 9px;
                                height: 14px;
                                background: url('./assets/arrow.png') no-repeat;
                                background-position: center;
                                background-size: 100%;
                                margin-top: 3px;
                                margin-left: 6px;
                                margin-right: 10px;
                            }
                        }
                    }

                    .r {
                        display: flex;
                        justify-content: center;
                        flex-direction: column;
                        align-items: center;
                        flex: 1;
                        min-width: 0;
                        height: 100%;
                    }
                }
            }

            .close {
                position: absolute;
                top: 20px;
                right: 30px;
                width: 21px;
                height: 21px;
                user-select: none;
                cursor: pointer;
            }

            .title {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                width: 512px;
                height: 76px;
                background: rgba(255,191,0,0.15);
                margin-bottom: 20px;

                p {
                    font-weight: 500;
                    font-size: 20px;
                    color: #050F0F;
                    line-height: 28px;
                }
            }

            .alertNotice {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 512px;
                height: 40px;
                background: #FFF0EF;
                border-radius: 4px;
                font-weight: 500;
                font-size: 14px;
                color: #FF3B30;
            }

            img {
                width: 512px;
                height: 289px;
                object-fit: contain;
            }

            .wordBg {
                display: flex;
                align-items: flex-start;
                width: 512px;
                height: 108px;
                background: #39464F;
                font-family: 'HYQiHei70S', sans-serif;
                font-weight: normal;
                /*font-size: 40px;*/
                font-size: 26px;
                color: #FFFFFF;
                line-height: 48px;
                text-align: left;
                font-style: normal;
                letter-spacing: 0;
                /*letter-spacing: -2.5px;*/
                padding: 8px 10px 0;
                box-sizing: border-box;
                white-space: pre-wrap;
                word-break: break-all;
                overflow: hidden;

                &.on {
                    font-size: 26px;
                    line-height: 44px;
                    letter-spacing: 0px;
                }

                i {
                    display: flex;
                    width: 17px;
                    min-width: 17px;
                    height: 25px;
                    background: url('./assets/arrow.png') no-repeat;
                    background-position: center;
                    background-size: 100%;
                    margin-top: 10px;
                    margin-right: 10px;
                    margin-left: 10px;
                }

                span {
                    font-family: 'HYQiHei70S', sans-serif;
                }
            }

            .mainContent {
                position: relative;
                display: flex;
                align-items: flex-start;
                flex-wrap: wrap;
                width: 277px;
                height: 260px;
                background: #39464F;
                font-family: 'HYQiHei70normal', sans-serif;
                font-weight: 400;
                font-size: 19px;
                color: #FFFFFF;
                line-height: 26px;
                text-align: left;
                font-style: normal;
                letter-spacing: -1px;
                padding: 13px 75px 0px 4px !important;
                box-sizing: border-box;
                white-space: pre-wrap;
                word-break: break-all;
                overflow: hidden;
            }

            .notice {
                display: flex;
                align-items: center;
                margin-top: 14px;

                i {
                    width: 14px;
                    height: 14px;
                    background: url('./assets/notice.png') no-repeat;
                    background-size: cover;
                    margin-right: 8px;
                }

                span {
                    font-weight: 500;
                    font-size: 14px;
                    color: #666666;
                    line-height: 22px;
                }
            }

            .btns {
                display: flex;
                flex-direction: row;
                align-items: center;
                margin: 24px auto 0;

                .btn {
                    width: 120px;
                    height: 32px;
                    line-height: 32px;
                    text-align: center;
                    background: #B9C3C3;
                    border-radius: 4px;
                    color: #FFF;
                    user-select: none;
                    cursor: pointer;

                    &:nth-of-type(2) {
                        margin-left: 20px;
                    }

                    &.g {
                        background: #41B48C;
                    }
                }
            }
        }

        .dialogContent {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 1020px;
            min-height: 580px;
            transform: translate(-50%, -50%);
            display: flex;
            flex-direction: column;
            background: #F9F9F9;
            box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
            border-radius: 4px;
            padding: 20px 30px 40px;
            box-sizing: border-box;

            &.breaking {
                width: 861px;
                height: 704px;

                .content {
                    padding-left: 40px;
                    box-sizing: border-box;

                    .left-container {
                        margin-right: 40px;

                        img {
                            display: flex;
                            min-width: 277px;
                            min-height: 156px;
                            max-width: 277px;
                            max-height: 156px;
                        }

                        .noImg {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            min-width: 277px;
                            min-height: 156px;
                            max-width: 277px;
                            max-height: 156px;
                            background: #E7EBEB;

                            i {
                                display: block;
                                width: 20px;
                                height: 20px;
                                background: url('./assets/noImg.png') no-repeat;
                                background-size: cover;
                                background-position: center;
                                margin-bottom: 6px;
                            }

                            span {
                                font-size: 14px;
                                color: #C4CBD1;
                                line-height: 20px;
                            }
                        }

                        .wordBg {
                            position: relative;
                            display: flex;
                            align-items: flex-start;
                            width: 277px;
                            height: 58px;
                            background: #39464F;
                            font-family: 'HYQiHei70S', sans-serif;
                            font-weight: bold;
                            font-size: 20px;
                            color: #FFFFFF;
                            line-height: 23px;
                            text-align: left;
                            font-style: normal;
                            letter-spacing: 0px;
                            padding: 6px 48px 0px 4px !important;
                            box-sizing: border-box;
                            white-space: pre-wrap;
                            word-break: break-all;
                            overflow: hidden;

                            i {
                                display: flex;
                                width: 9px;
                                min-width: 9px;
                                height: 14px;
                                background: url('./assets/arrow.png') no-repeat;
                                background-position: center;
                                background-size: 100%;
                                margin-top: 3px;
                                margin-left: 6px;
                                margin-right: 10px;
                            }
                        }

                        .mainContent {
                            position: relative;
                            display: flex;
                            align-items: flex-start;
                            flex-wrap: wrap;
                            width: 277px;
                            height: 260px;
                            background: #39464F;
                            font-family: 'HYQiHei70normal', sans-serif;
                            font-weight: 400;
                            font-size: 19px;
                            color: #FFFFFF;
                            line-height: 26px;
                            text-align: left;
                            font-style: normal;
                            letter-spacing: -1px;
                            padding: 13px 75px 0px 4px !important;
                            box-sizing: border-box;
                            white-space: pre-wrap;
                            word-break: break-all;
                            overflow: hidden;
                        }

                        .notice {
                            display: flex;
                            align-items: baseline;
                            margin-top: 14px;
                            width: 277px;

                            i {
                                width: 14px;
                                min-width: 14px;
                                height: 14px;
                                background: url('./assets/notice.png') no-repeat;
                                background-size: cover;
                                background-position: center;
                                margin-right: 8px;
                            }

                            span {
                                font-weight: 500;
                                font-size: 14px;
                                color: #666666;
                                line-height: 22px;
                            }
                        }
                    }

                    .right-container {
                        textarea {
                            width: 404px !important;
                        }

                        .col {
                            position: relative;

                            .num {
                                position: absolute;
                                bottom: 14px;
                                right: 14px;
                                font-weight: 500;
                                font-size: 14px;
                                color: #B9C3C3;
                                line-height: 20px;
                            }
                        }

                        .mainContent {
                            position: relative;
                            width: 404px;
                            height: 204px;
                            background: rgba(185,195,195,0.2);
                            border-radius: 2px;
                            outline: none;
                            resize: none;           
                            padding: 10px 242px 19px 14px;
                            box-sizing: border-box;
                            font-weight: 500;
                            font-size: 14px;
                            color: #323B4B;     
                            line-height: 21px;

                            &::-webkit-scrollbar {
                                width: 4px;
                            }
                            &::-webkit-scrollbar-thumb {
                                background: rgba(185, 195, 195, 0.3);
                                border-radius: 4px;
                            }
                        }
                    }
                }
            }

            &>.title {
                font-size: 24px;
                line-height: 33px;
                color: #050F0F;
                font-weight: bold;
                margin-bottom: 30px;
            }

            .close {
                position: absolute;
                top: 20px;
                right: 30px;
                width: 21px;
                height: 21px;
                user-select: none;
                cursor: pointer;
            }

            .content {
                display: flex;
                width: 100%;
                flex: 1;
                min-height: 0;

                .left-container {
                    margin-right: 40px;

                    img {
                        display: flex;
                        min-width: 512px;
                        min-height: 289px;
                        max-width: 512px;
                        max-height: 289px;
                    }

                    .noImg {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        min-width: 512px;
                        min-height: 289px;
                        max-width: 512px;
                        max-height: 289px;
                        background: #E7EBEB;

                        i {
                            display: block;
                            width: 20px;
                            height: 20px;
                            background: url('./assets/noImg.png') no-repeat;
                            background-size: cover;
                            background-position: center;
                            margin-bottom: 6px;
                        }

                        span {
                            font-size: 14px;
                            color: #C4CBD1;
                            line-height: 20px;
                        }
                    }

                    .wordBg {
                        position: relative;
                        display: flex;
                        align-items: flex-start;
                        width: 512px;
                        height: 108px;
                        background: #39464F;
                        font-family: 'HYQiHei70S', sans-serif;
                        font-weight: normal;
                        /*font-size: 40px;*/
                        font-size: 26px;
                        color: #FFFFFF;
                        line-height: 48px;
                        text-align: left;
                        font-style: normal;
                        /*letter-spacing: -2.5px;*/
                        letter-spacing: 0;
                        padding: 8px 10px 0;
                        box-sizing: border-box;
                        white-space: pre-wrap;
                        word-break: break-all;
                        overflow: hidden;

                        &.on {
                            font-size: 26px;
                            line-height: 44px;
                            letter-spacing: 0px;
                        }

                        i {
                            display: flex;
                            width: 17px;
                            min-width: 17px;
                            height: 25px;
                            background: url('./assets/arrow.png') no-repeat;
                            background-position: center;
                            background-size: 100%;
                            margin-top: 10px;
                            margin-right: 10px;
                            margin-left: 10px;
                        }

                        span {
                            font-family: 'HYQiHei70S', sans-serif;
                        }
                    }

                    .notice {
                        display: flex;
                        align-items: center;
                        margin-top: 14px;

                        i {
                            width: 14px;
                            height: 14px;
                            background: url('./assets/notice.png') no-repeat;
                            background-size: cover;
                            margin-right: 8px;
                        }

                        span {
                            font-weight: 500;
                            font-size: 14px;
                            color: #666666;
                            line-height: 22px;
                        }
                    }
                }

                .right-container {
                    display: flex;
                    flex-direction: column;

                    .row {
                        display: flex;
                        margin-bottom: 20px;

                        .prioritySelect {
                            width: 264px;
                            height: 30px;

                            .el-input {
                                height: 100%;

                                input {
                                    height: 100%;
                                    border: none;
                                    background: rgba(185, 195, 195, 0.2);
                                }

                                .el-input__suffix {
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                }
                            }
                        }

                        &.center {
                            align-items: center;
                        }

                        .pt {
                            font-weight: bold;
                            font-size: 14px;
                            color: #323B4B;
                            line-height: 20px;
                            margin-right: 4px; 

                            &.alert {
                                position: relative;

                                &::before {
                                    position: absolute;
                                    left: -10px;
                                    display: block;
                                    content: '*';
                                    color: red;
                                }
                            }
                        }



                        .notice {
                            position: relative;
                            width: 16px;
                            height: 16px;
                            background: url('./assets/alert.png') no-repeat;
                            background-size: cover;
                            background-position: center;
                            margin-right: 16px;
                            user-select: none;
                            cursor: pointer;

                            &:hover {
                                p {
                                    display: flex;
                                }
                            }

                            p {
                                position: absolute;
                                top: -44px;
                                left: -18px;
                                display: none;
                                justify-content: center;
                                align-items: center;
                                width: 158px;
                                height: 40px;
                                background: rgba(5, 10, 15, 0.8);
                                border-radius: 4px;
                                font-weight: bold;
                                font-size: 14px;
                                color: #FFFFFF;
                            }
                        }

                        .datePickerDom-time {
                            margin-left: 2px;
                        }

                        .datePickerDom1-time {
                            margin-left: 2px;
                        }

                        .el-date-picker,
                        .el-time-picker,
                        .el-date-editor {
                            &.datePickerDom-date,
                            &.datePickerDom-time,
                            &.datePickerDom1-date,
                            &.datePickerDom1-time {
                                display: flex;
                                align-items: center;
                                width: 132px;
                                height: 30px;

                                input {
                                    height: 100%;
                                    border: none;
                                    background: rgba(185, 195, 195, 0.2);
                                    color: #323B4B;
                                    padding-left: 30px;
                                    box-sizing: border-box;
                                }

                                .el-input__prefix {
                                    display: flex;
                                    align-items: center;
                                }

                                .el-input__suffix {
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                }

                                .el-input__icon {
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                }

                                .el-input {
                                    height: 100%;

                                    input {
                                        height: 100%;
                                        border: none;
                                        background: rgba(185, 195, 195, 0.2);
                                        color: #323B4B;
                                        padding-left: 30px;
                                        box-sizing: border-box;
                                    }

                                    .el-input__prefix {
                                        display: flex;
                                        align-items: center;
                                    }

                                    .el-input__suffix {
                                        display: flex;
                                        justify-content: center;
                                        align-items: center;
                                    }
                                }
                            }
                        }

                        .priority {
                            padding: 0 14px;
                            box-sizing: border-box;
                        }

                        .select {
                            display: flex;
                            align-items: center;
                            margin-left: 26px;

                            .title {
                                font-weight: bold;
                                font-size: 14px;
                                line-height: 30px;
                                color: #323B4B;
                                margin-right: 8px;
                            }

                            .unit {
                                font-weight: bold;
                                font-size: 14px;
                                line-height: 30px;
                                color: #323B4B;
                                margin-left: 8px;
                            }

                            .preview {
                                position: relative;
                                width: 18px;
                                height: 18px;
                                background: url('./assets/preview.png') no-repeat;
                                background-size: cover;
                                background-position: center;
                                margin-left: 10px;
                                user-select: none;
                                cursor: pointer;

                                &:hover {
                                    background: url('./assets/previewOn.png') no-repeat;
                                    background-size: cover;
                                    background-position: center;
                                    margin-left: 10px;

                                    .info {
                                        display: flex;
                                    }
                                }

                                .info {
                                    position: absolute;
                                    top: 24px;
                                    right: 0;
                                    display: none;
                                    flex-direction: column;
                                    width: 178px;
                                    padding: 16px 20px;
                                    box-sizing: border-box;
                                    background: rgba(5, 15, 15, 0.8);
                                    border-radius: 4px;

                                    span {
                                        font-weight: 500;
                                        font-size: 14px;
                                        color: #41B48C;
                                        line-height: 20px;
                                        margin-bottom: 10px;
                                    }

                                    p {
                                        font-size: 14px;
                                        color: #829191;
                                        line-height: 20px;
                                        margin-bottom: 12px;

                                        &:nth-last-of-type(1) {
                                            margin-bottom: 0;
                                        }
                                    }
                                }
                            }

                            .el-select {
                                width: 50px;
                                height: 30px;
                                border-radius: 2px;

                                .el-input {
                                    height: 100%;
                                    width: 100%;
                                }

                                .el-input__inner {
                                    padding: 0;
                                    height: 100%;
                                    width: 100%;
                                    background: rgba(185, 195, 195, 0.2);
                                    border: none;  
                                    padding-left: 8px;
                                    box-sizing: border-box; 
                                    color: #323B4B;
                                    max-height: 30px !important;
                                }

                                .el-select__caret {
                                    line-height: 30px;
                                }
                            }
                        }

                        & > input {
                            max-width: 264px !important;
                            min-width: 264px !important;
                            width: 264px;
                            height: 30px;
                            background: rgba(185,195,195,0.2);
                            border-radius: 2px;
                            outline: none;
                            border: none;
                            color: #323B4B;
                            
                            &.priorty {
                                padding: 0 14px !important;
                                box-sizing: border-box;

                                &::placeholder {
                                    color: #B9C3C3;
                                }
                            }
                        }
                        
                        .t {
                            font-weight: bold;
                            font-size: 14px;
                            color: #323B4B;
                            line-height: 20px;
                            margin-right: 24px;
                            min-width: 56px;

                            &.alert {
                                position: relative;

                                &::before {
                                    position: absolute;
                                    left: -10px;
                                    display: block;
                                    content: '*';
                                    color: red;
                                }
                            }
                        }

                        .pic {
                            width: 192px;
                            height: 108px;
                            border-radius: 4px;
                            margin-right: 13px;
                            object-fit: contain;
                        }

                        .noImg {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            width: 192px;
                            height: 108px;
                            background: #E7EBEB;

                            i {
                                display: block;
                                width: 20px;
                                height: 20px;
                                background: url('./assets/noImg.png') no-repeat;
                                background-size: cover;
                                background-position: center;
                                margin-bottom: 6px;
                            }

                            span {
                                font-size: 14px;
                                color: #C4CBD1;
                                line-height: 20px;
                            }
                        }

                        .btns {
                            display: flex;
                            flex-direction: column;

                            .change {
                                display: flex;
                                align-items: center;
                                margin-bottom: 10px;
                                user-select: none;
                                cursor: pointer;

                                i {
                                    width: 16px;
                                    height: 16px;
                                    background: url('./assets/change.png') no-repeat;
                                    background-size: cover;
                                    margin-right: 4px;
                                }

                                span {
                                    font-weight: bold;
                                    font-size: 14px;
                                    color: #829191;
                                }
                            }

                            .clip {
                                display: flex;
                                align-items: center;
                                user-select: none;
                                cursor: pointer;

                                i {
                                    width: 16px;
                                    height: 16px;
                                    background: url('./assets/clip.png') no-repeat;
                                    background-size: cover;
                                    margin-right: 4px;
                                }

                                span {
                                    font-weight: bold;
                                    font-size: 14px;
                                    color: #829191;
                                }
                            }
                        }
                    }

                    .col {
                        position: relative;
                        display: flex;
                        flex-direction: column;
                        margin-bottom: 20px;

                        .num {
                            position: absolute;
                            bottom: 14px;
                            right: 14px;
                            font-weight: 500;
                            font-size: 14px;
                            color: #B9C3C3;
                            line-height: 20px;
                        }

                        .t {
                            font-weight: bold;
                            font-size: 14px;
                            color: #323B4B;
                            line-height: 20px;
                            margin-bottom: 10px;
                            min-width: 56px;

                            &.alert {
                                position: relative;

                                &::before {
                                    position: absolute;
                                    left: -10px;
                                    display: block;
                                    content: '*';
                                    color: red;
                                }
                            }
                        }

                        textarea {
                            width: 345px;
                            height: 62px;
                            background: rgba(185,195,195,0.2);
                            border-radius: 2px;
                            outline: none;
                            resize: none;
                            padding: 10px 14px;
                            box-sizing: border-box;
                            font-weight: 500;
                            font-size: 14px;
                            color: #323B4B;
                            line-height: 21px;
                        }
                    }
                }
            }

            & > .btns {
                display: flex;
                flex-direction: row;
                align-items: center;
                margin: 24px auto 0;

                .btn {
                    width: 120px;
                    height: 32px;
                    line-height: 32px;
                    text-align: center;
                    background: #B9C3C3;
                    border-radius: 4px;
                    color: #FFF;
                    user-select: none;
                    cursor: pointer;

                    &:nth-of-type(2) {
                        margin-left: 20px;
                    }

                    &.g {
                        background: #41B48C;
                    }
                }
            }
        }
    }

    .timeOutSelect {
        .el-select-dropdown__item.selected {
            color: #41B48C;
        }
    }

    .createTimePoper .el-date-table td.current:not(.disabled) span {
        color: #FFF !important;
    }

    .datePickerDom-poper,.datePickerDom1-poper {
        .el-date-table td.today.current span {
            color: #FFF !important;
        }
    }
</style>